<app-modal-container cardClass="card-width-50vw">
  <div class="modal-header-content">
    {{ 'title_confirm_tenant_creation' | translate }}
  </div>
  <div class="modal-body-content">
    <div class="row flex-column">
      <div class="col-12 mb-4">
        <p class="text-black mb-0">
          {{ 'subtitle_create_tenant_properties_confirmation' | translate }}&nbsp;<span class="fw-bold">{{
            'subtitle_create_tenant_values_cannot_be_changed_confirmation' | translate
          }}</span>
        </p>
      </div>
      <div class="col-12 d-flex flex-column mb-4">
        <p class="text-black h3 mb-1">{{ 'tenant_name' | translate }}</p>
        <p class="mb-0" data-e2e-id="tenant-name">{{ getTenantName() }}</p>
      </div>
      @if (getSalesforceAccount(); as salesforceAccount) {
        <div class="col-12 d-flex flex-column mb-4">
          <p class="text-black h3 mb-1">{{ 'salesforce_account_name' | translate }}</p>
          <p class="mb-0" data-e2e-id="salesforce-account-name">{{ salesforceAccount }}</p>
        </div>
      }
      <div class="col-12 d-flex flex-column mb-4">
        <p class="text-black h3 mb-1">{{ 'label_tenant_subdomain' | translate }}</p>
        <p class="mb-0">{{ 'https_slash' | translate }}{{ context.tenantDetails[$tenant.domain] }}.{{ context.tenantBaseUrl }}</p>
      </div>
      <div class="col-12 d-flex flex-column mb-4">
        <p class="text-black h3 mb-1">{{ 'label_package' | translate }}</p>
        <p class="mb-0">{{ context.packageName }}</p>
      </div>
      <div class="col-12 d-flex flex-column mb-4">
        <p class="text-black h3 mb-1">{{ 'digital_properties' | translate }}</p>
        <p class="mb-0">{{ context.tenantDetails[$tenant.digitalPropertyLimit] }}</p>
      </div>
      <div class="col-12 d-flex flex-column mb-4">
        <p class="text-black h3 mb-1">{{ 'label_page_limit_for_monitoring' | translate }}</p>
        <p class="mb-0">{{ context.tenantDetails[$tenant.monitoringPagesPerDigitalPropertyLimit] }}</p>
      </div>
      <div class="col-12 d-flex flex-column mb-4">
        <p class="text-black h3 mb-1">{{ 'label_page_limit_for_pdf_testing' | translate }}</p>
        <p class="mb-0">{{ context.tenantDetails[$tenant.pdfPagesTestLimit] }}</p>
      </div>
      <div class="col-12 d-flex flex-column" [ngClass]="{ 'mb-4': shouldShowMarginBottomForAcademySeats() }">
        <p class="text-black h3 mb-1">{{ 'label_academy_seats' | translate }}</p>
        <p class="mb-0">{{ context.tenantDetails[$academy.seatLimit] }}</p>
      </div>
      @if (context.tenantDetails[$tenant.userWayWebsiteLimit]) {
        <div class="col-12 d-flex flex-column" [ngClass]="{ 'mb-4': isAvailableConfidentialScanning() }">
          <p class="text-black h3 mb-1">{{ 'label_widget_websites' | translate }}</p>
          <p class="mb-0">{{ context.tenantDetails[$tenant.userWayWebsiteLimit] }}</p>
        </div>
      }
      <div class="col-12 d-flex flex-column mb-4" *featureFlag="FeatureFlagCollection.digitalAssetsPrivacySetting">
        <p class="text-black h3 mb-1">{{ 'confidential_scanning' | translate }}</p>
        <p class="mb-0">{{ (getConfidentialScanningEnabled() ? 'enabled' : 'disabled') | translate }}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer-content">
    <div class="row">
      <div class="col-auto me-3 pe-0">
        <button class="btn btn-primary" (click)="closeModal(true)">{{ 'label_create_tenant' | translate }}</button>
      </div>
      <div class="col-auto px-0">
        <button class="btn btn-outline-primary" (click)="closeModal(false)">{{ 'form_cancel' | translate }}</button>
      </div>
    </div>
  </div>
</app-modal-container>
